import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
import ThemeCard from '../components/ThemeCard';
import { themes } from '../utils/mockData';
const ThematicAnalysis = () => {
  const [filter, setFilter] = useState('all');
  // Simplified filtering
  const filteredThemes = filter === 'all' ? themes : filter === 'treaty' ? themes.filter(theme => theme.treatyRelevant) : themes.filter(theme => theme.priority === filter);
  return <div data-id="element-298">
      <div className="mb-6" data-id="element-299">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-300">Thematic Analysis</h1>
        <p className="mt-1 text-sm text-gray-600" data-id="element-301">
          Key issues from submissions
        </p>
      </div>
      {/* Simplified filtering UI */}
      <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-302">
        <div className="relative rounded-md w-full sm:w-64" data-id="element-303">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-304">
            <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-305" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Search themes..." data-id="element-306" />
        </div>
        <select className="block w-full sm:w-auto pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={filter} onChange={e => setFilter(e.target.value)} data-id="element-307">
          <option value="all" data-id="element-308">All Themes</option>
          <option value="critical" data-id="element-309">Critical Priority</option>
          <option value="high" data-id="element-310">High Priority</option>
          <option value="medium" data-id="element-311">Medium Priority</option>
          <option value="low" data-id="element-312">Low Priority</option>
          <option value="treaty" data-id="element-313">Treaty Relevant</option>
        </select>
      </div>
      {/* Theme cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-314">
        {filteredThemes.map((theme, index) => <ThemeCard key={index} title={theme.title} count={theme.count} description={theme.description} priority={theme.priority as any} confidence={theme.confidence} treatyRelevant={theme.treatyRelevant} data-id="element-315" />)}
      </div>
      {filteredThemes.length === 0 && <div className="text-center py-12" data-id="element-316">
          <p className="text-gray-500" data-id="element-317">No themes match your current filters.</p>
        </div>}
    </div>;
};
export default ThematicAnalysis;